import axios from 'axios'

export const getBikeQuickQuotes = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getTwoWheelerQuickQuotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getBikeFullQuote = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getTwoWheelerFullQuotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const verifyKYCForBike = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/verifykyc/bike`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getProposalDetailsBike = async (token, enquiryId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmotorfullquoterequest?enquiryId=${enquiryId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getAddOnsListBike = async (token) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getBikeAddOns`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
